import styled from 'styled-components'
import Button from 'components/Button/Button'

export const StyledImmoPointsButton = styled(Button)`
  background-color: #333333 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 600 !important;

  :hover {
    color: #ffffff !important;
    background-color: #474747 !important;
  }
`
